module.exports = __webpack_public_path__ + "img/icon-heart.57713b89.png";